import { Box } from '@mui/material';
import Stack from '@mui/material/Stack';

import ElectricBorder from '@/features/Dashboard/components/ElectricBorder/ElectricBorder';
import { useWidgetAnimation } from '@/features/Dashboard/context/WidgetAnimation/hooks';

import Tile from './Tile';
import { TileType } from './types';

const Tiles = ({ tiles }: { tiles: TileType[] }) => {
  const { elementsToAnimateId } = useWidgetAnimation();

  return (
    <Stack
      useFlexGap
      className='highlighted-prices__container'
      direction='row'
      flexWrap='wrap'
      spacing={{ xs: 2, sm: 3 }}
      sx={{ width: '100%', gridColumn: { lg: 'span 2' } }}
    >
      {!!tiles.length &&
        tiles.map(tile => {
          return (
            <Box
              key={tile.id}
              id={tile.id}
              sx={{
                width: { xs: 'calc(100% - 18px)', sm: 'calc(50% - 18px)', lg: 'calc(25% - 18px)' },
                minWidth: 230
              }}
            >
              <ElectricBorder animate={!!elementsToAnimateId?.includes(tile.id)}>
                <Tile tile={tile} />
              </ElectricBorder>
            </Box>
          );
        })}
    </Stack>
  );
};

export default Tiles;
